import { render, staticRenderFns } from "./ExplorerTagSelect.vue?vue&type=template&id=bf09643a"
import script from "./ExplorerTagSelect.vue?vue&type=script&lang=js"
export * from "./ExplorerTagSelect.vue?vue&type=script&lang=js"
import style0 from "./ExplorerTagSelect.vue?vue&type=style&index=0&id=bf09643a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports